import React, {Component} from 'react';
import {close_popup, show_popup} from "../functions";

class PreviewPhotoPopup extends Component {
    constructor(props) {
        super(props);
    }

    goBack() {
        close_popup();
    }

    render() {
        return (
            <div className="row example-preview-photo">
                <div className="col-12 text-center">
                    <div className="row m-3">
                        <div className="col-12 text-center">
                            <img width="100%" src={this.props.src+'&size=1000'} alt="Preview"/>
                        </div>
                    </div>
                    <div className="row mx-3 mb-3">
                        <div className="go-btn go-back mx-auto" onClick={this.goBack.bind(this)} />
                    </div>
                </div>
            </div>
        )
    }
}

class PreviewPhoto extends Component {
    constructor(props) {
        super(props);
    }
    showPreviewPopup() {
        show_popup(<PreviewPhotoPopup src={this.props.src} />, {auto_close:false})
    }
    render() {
        return (
            <><img onClick={this.showPreviewPopup.bind(this)} src={this.props.src}/>{this.props.text ? this.props.text : ''}</>
        );
    }
}

export default PreviewPhoto;